/* eslint-disable react/no-array-index-key */
import { Container } from 'react-bootstrap';
import AccordionComp from '../../../Components/accordionComp/AccordionComp';
import { SectionHeadingMed } from '../../../Components/Headings';
import './frequentlyAskedQues.css';

const questions = [
  {
    heading:
      'What kind of doctors will be available for unlimited online consultations?',
    desc: 'Prof. Dr. Nadia Khurshid Ahmed has the following degrees: M.B.B.S, F.C.P.S.',
    content: '(Gynecology & Obstetrician), M.C.P.S'
  },
  {
    heading:
      'What kind of doctors will be available for unlimited online consultations?',
    desc: 'Prof. Dr. Nadia Khurshid Ahmed has the following degrees: M.B.B.S, F.C.P.S.',
    content: '(Gynecology & Obstetrician), M.C.P.S'
  },
  {
    heading:
      'What kind of doctors will be available for unlimited online consultations?',
    desc: 'Prof. Dr. Nadia Khurshid Ahmed has the following degrees: M.B.B.S, F.C.P.S.',
    content: '(Gynecology & Obstetrician), M.C.P.S'
  },
  {
    heading:
      'What kind of doctors will be available for unlimited online consultations?',
    desc: 'Prof. Dr. Nadia Khurshid Ahmed has the following degrees: M.B.B.S, F.C.P.S.',
    content: '(Gynecology & Obstetrician), M.C.P.S'
  }
];

function FrequentlyAskedQues() {
  return (
    <div className="frequentlyAskedQues">
      <Container>
        <SectionHeadingMed text="Frequently Asked Questions" />
        <AccordionComp data={questions} />
      </Container>
    </div>
  );
}

export default FrequentlyAskedQues;
